import { render, staticRenderFns } from "./JpFooter.vue?vue&type=template&id=380f9d08&scoped=true"
var script = {}
import style0 from "./JpFooter.vue?vue&type=style&index=0&id=380f9d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f9d08",
  null
  
)

export default component.exports